const addParticipantStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    seatsContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    legendContainer: {
      alignSelf: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    legendContent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    filled: {
      fill: '#A93226',
    },
    selected: {
      fill: '#229954',
    },
    empty: {
      fill: '#AED6F1',
    },
  };
};

export default addParticipantStyles;
